import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const ImageRevealOnScroll = ({ src, alt, direction = 'left' }) => {
  const { ref, inView } = useInView({
    threshold: 0.3,
    triggerOnce: true
  });

  const slideVariants = {
    hidden: {
      x: direction === 'left' ? -100 : 100,
      opacity: 0,
      scale: 0.8
    },
    visible: {
      x: 0,
      opacity: 1,
      scale: 1,
      transition: {
        duration: 1.2,
        ease: [0.6, 0.05, 0.01, 0.9]
      }
    }
  };

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={slideVariants}
      className="relative overflow-hidden aspect-video group"
      whileHover={{ scale: 1.03 }}
      transition={{ duration: 0.4 }}
    >
      {/* Image with zoom on hover */}
      <motion.img
        src={src}
        alt={alt}
        className="w-full h-full object-cover"
        whileHover={{ scale: 1.15 }}
        transition={{ duration: 0.8, ease: [0.6, 0.05, 0.01, 0.9] }}
      />
      
      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-navy-dark via-transparent to-transparent opacity-50 group-hover:opacity-30 transition-opacity duration-500" />
      
      {/* Animated border on hover */}
      <div className="absolute inset-0 border-4 border-white opacity-0 group-hover:opacity-20 transition-opacity duration-500" />
    </motion.div>
  );
};

export default ImageRevealOnScroll;
